<template>
  <div class="loader">
    <div class="loader__circle">
      <Icon name="24/spinner"/>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon/Icon.vue';

export default {
  name: 'Loader',
  components: { Icon },
};
</script>

<style lang="scss" scoped>
@import "Loader";
</style>
